export default __webpack_public_path__ + "static/media/cardimg4.4e2189ad.png";